// extracted by mini-css-extract-plugin
export var arrow = "hero-module--arrow--94252";
export var domainPrices = "hero-module--domain-prices--2f47d";
export var domainheroContent = "hero-module--domainhero-content--1a913";
export var heroButton = "hero-module--hero-button--6e533";
export var heroImg = "hero-module--hero-img--e51e9";
export var heroP = "hero-module--hero-p--ffc8a";
export var pbutton = "hero-module--pbutton--2c316";
export var planbtn = "hero-module--planbtn--f9279";
export var pricingDiv = "hero-module--pricing-div--a68ea";